export default function BurnabyZoning() {
  const zones = [
    {
      zone: 'R1 - R5 Residential',
      status: 'Permitted',
      conditions: 'Principal residence only, max 2 guests per bedroom',
      icon: 'ri-checkbox-circle-fill',
      color: 'text-green-600'
    },
    {
      zone: 'RM - Multi-Family',
      status: 'Conditional',
      conditions: 'Subject to strata bylaws and building regulations',
      icon: 'ri-error-warning-fill',
      color: 'text-amber-500'
    },
    {
      zone: 'C - Commercial',
      status: 'Not Permitted',
      conditions: 'STRs not allowed in commercial zones',
      icon: 'ri-close-circle-fill',
      color: 'text-red-500'
    },
    {
      zone: 'P - Park/Institutional',
      status: 'Not Permitted',
      conditions: 'No residential STR activity allowed',
      icon: 'ri-close-circle-fill',
      color: 'text-red-500'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            {/* Use inline style for the semi‑transparent background to avoid the
                Tailwind arbitrary value syntax that can cause parsing errors */}
            <span
              className="inline-block text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4"
              style={{ backgroundColor: 'rgba(136,38,41,0.1)' }}
            >
              Zoning Regulations
            </span>

            <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
              Where Can You Operate an STR in Burnaby?
            </h2>
            <p className="text-lg text-[#505A5A]/70 leading-relaxed mb-8">
              Burnaby's zoning bylaws determine where short-term rentals are permitted. Understanding these restrictions is crucial before investing in or listing a property.
            </p>

            <div className="space-y-4">
              {zones.map((zone, index) => (
                <div
                  key={index}
                  className="bg-[#F8F8F8] rounded-xl p-5 flex items-start gap-4"
                >
                  <i className={`${zone.icon} text-2xl ${zone.color} flex-shrink-0 mt-1`}></i>
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <h4 className="font-semibold text-[#505A5A]">{zone.zone}</h4>
                      <span className={`text-sm font-medium ${zone.color}`}>{zone.status}</span>
                    </div>
                    <p className="text-sm text-[#505A5A]/60">{zone.conditions}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/545feb52a2b453ff3bfce9fe11492ba4.jpg"
              alt="Burnaby residential areas"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-lg max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <i className="ri-information-line text-2xl text-[#882629]"></i>
                <span className="font-semibold text-[#505A5A]">Pro Tip</span>
              </div>
              <p className="text-sm text-[#505A5A]/70">
                Always verify your specific property's zoning with the City of Burnaby before applying for an STR license.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
